import { createContext, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import {
  CLIENT_ADMIN_PORTAL_LEGACY_BASE,
  buildClientAdminPortalPaths,
  resolveClientAdminPortalBase,
} from "../constants/clientAdminPortalRoutes";

const ClientPortalBaseContext = createContext(CLIENT_ADMIN_PORTAL_LEGACY_BASE);

export function ClientPortalBaseProvider({ base, children }) {
  const value = base || CLIENT_ADMIN_PORTAL_LEGACY_BASE;
  return (
    <ClientPortalBaseContext.Provider value={value}>{children}</ClientPortalBaseContext.Provider>
  );
}

export function useClientPortalBase() {
  const fromContext = useContext(ClientPortalBaseContext);
  const { pathname } = useLocation();
  return fromContext || resolveClientAdminPortalBase(pathname);
}

export function useClientPortalPaths() {
  const base = useClientPortalBase();
  return useMemo(() => buildClientAdminPortalPaths(base), [base]);
}
